import styled, { css } from "../../../styled/index";
import { shadeAlternate } from "../../..";
export const ListSection = styled("div") `
  margin-top: 6px;
  &:first-child {
    margin-top: 0;
  }
`;
export const List = styled("ul") `
  list-style: disc;
  padding: 0 0 0 20px;
`;
export const ListItem = styled("li") `
  margin-top: 2px;
  ${({ noStock }) => !noStock
    ? ``
    : css `
          color: #bd362f;
          font-weight: 600;
          text-decoration: line-through;
        `}
`;
export const ListItemBig = styled("li") `
  margin-top: 2px;
  font-size: ${({ theme }) => theme.font.size}px;
`;
export const ListItemHighlight = styled("span") `
  background: ${({ theme }) => shadeAlternate(0.07, theme.colors.background)};
  padding: 3px 6px;
  border-radius: 5px;
  margin-left: 5px;
  font-size: 0.85rem;
  font-weight: 500;
`;
//# sourceMappingURL=index.js.map